import { JD_ID, GROUPON_ID, SUPERMARKET_ID } from "../../constants";

export const isBBShopMerchant = (user) => {
    const merchant = user ? user.merchant : null;
    if (merchant) {
        return [SUPERMARKET_ID, JD_ID, GROUPON_ID].includes(merchant.id);
    }
    return false;
}

export const isGrouponMerchant = (user) => {
  return user && user.merchant && user.merchant.type === 19;
};

export const merchantHasCommission = (user, settings = null) => {
    if(!user || !user.merchant) return false;
    // Balance-topup VIP coexists with per-product commission (see Base.merchantHasCommission).
    if (
        isBBShopMerchant(user) ||
        isAdminWithDabazaShop(user) ||
        (isThirdPartyShopHasWeapp(user) && shopHasAgents(user))
    ) {
        return true;
    }
    return false;
}

export const isAdminWithDabazaShop = (user) => {
    return user.admin && isDabazaShop(user);
}


export const isArticleEnabled = (settings) => {
    return settings && settings.enable_article;
}
export const isLotteryQrcodeEnabled = (settings) => {
    return settings && settings.enable_lottery_qrcode;
}

export const isLotteryEnabled = (user, settings) => {
    if(isLotteryQrcodeEnabled(settings)){
        return true;
    }
    return user && user.merchant && user.merchant.enabled_lottery;
}

export const isMembersEnabled = (settings) => {
    return settings && settings.enable_membership;
}

export const isTaskCenterEnabled = (settings) => {
    return settings && settings.enable_task_center;
}

export const isDabazaShop = (user) => {
    return (
        (user.merchant && user.merchant.is_dabaza_shop) ||
        user.merchant.type === 14
    );
}

export const isSoleLotteryWeapp = (user) => {
    return (
        user &&
        user.merchant &&
        user.merchant.enabled_lottery &&
        user.merchant.type === 15
    );
}

export const isEnabledSpecifiedUsers = (user) => {
    return user.merchant && user.merchant.enabled_specified_user;
}

export const isThirdPartyShop = (user) => {
    return [12, 13, 15, 17].includes(user.merchant.type);
}

export const isThirdPartyShopHasWeapp = (user) => {
    return isThirdPartyShop(user) && user.merchant.has_weapp;
}

export const isLbsShop = (user) => {
    return user.merchant && user.merchant.is_lbs && !user.merchant.is_bulutbazar_lbs_shop;
}

export const isSaasLbsShop = (user, settings) => {
    if (settings && settings.is_saas_lbs_shop) {
        return true;
    }
    return !!(user && user.merchant && user.merchant.is_saas_lbs_shop);
}

export const isSaasShop = (user, settings) => {
    if (settings && (settings.is_saas_shop || settings.is_saas_lbs_shop)) {
        return true;
    }
    return !!(user && user.merchant && user.merchant.is_saas_shop);
}

export const isMerchantCuratedPoiMode = (settings) => {
    if (!settings || !settings.lbs_address_mode) {
        return false;
    }
    return settings.lbs_address_mode === "merchant_poi"
        || settings.lbs_address_mode === "merchant_poi_buildings";
}

export const isMerchantPoiBuildingsMode = (settings) => {
    return settings && settings.lbs_address_mode === "merchant_poi_buildings";
}
export const isBBLbsShop = (user) => {
    return user.merchant && user.merchant.is_bulutbazar_lbs_shop;
}

export const shopHasAgents = (user) => {

    return user.merchant && user.merchant.has_agents;
}